import {
  FAQ_SETTINGS_START_EDIT,
  FAQ_SETTINGS_SET_FIELD,
  FAQ_SETTINGS_CANCEL_EDIT,
  FAQ_SETTINGS_FINISH_EDIT,
} from 'constants/action_names';

export const startEdit = faq => ({
  type: FAQ_SETTINGS_START_EDIT,
  faq,
});

export const setField = (field, value) => ({
  type: FAQ_SETTINGS_SET_FIELD,
  field,
  value,
});

export const cancelEdit = () => ({
  type: FAQ_SETTINGS_CANCEL_EDIT,
});

export const finishEdit = faq => {
  return {
    type: FAQ_SETTINGS_FINISH_EDIT,
    faq,
  };
};
